import { render } from "./NewInstitute.vue?vue&type=template&id=a49f7306&ts=true"
import script from "./NewInstitute.vue?vue&type=script&lang=ts"
export * from "./NewInstitute.vue?vue&type=script&lang=ts"

import "./NewInstitute.vue?vue&type=style&index=0&id=a49f7306&lang=css"
import "./NewInstitute.vue?vue&type=style&index=1&id=a49f7306&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__